import { CIcon } from '~/icons/types'

export const ciRedo: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M13.5 8A1.5 1.5 0 0 0 15 9.5h6c.021 0 .041-.005.062-.006l.041-.004c.186-.013.362-.056.523-.13l.025-.013c.171-.083.323-.195.45-.333.004-.005.01-.006.015-.011.007-.007.008-.017.014-.025.118-.137.212-.293.275-.466l.018-.059c.046-.145.077-.294.077-.453V2a1.5 1.5 0 1 0-3 0v2.631l-.509-.458a10.543 10.543 0 0 0-6.353-2.605 10.598 10.598 0 0 0-6.604 1.877 10.543 10.543 0 0 0-4.032 5.558 10.55 10.55 0 0 0 .264 6.861 10.545 10.545 0 0 0 4.447 5.23 10.557 10.557 0 0 0 6.73 1.364 10.54 10.54 0 0 0 6.133-3.086 10.543 10.543 0 0 0 2.916-6.217 1.5 1.5 0 0 0-2.983-.315 7.53 7.53 0 0 1-2.083 4.439 7.538 7.538 0 0 1-4.381 2.205 7.561 7.561 0 0 1-4.807-.974 7.538 7.538 0 0 1-3.177-3.736 7.536 7.536 0 0 1-.188-4.901 7.526 7.526 0 0 1 2.88-3.969 7.52 7.52 0 0 1 4.717-1.341 7.525 7.525 0 0 1 4.526 1.851l.097.086H15A1.5 1.5 0 0 0 13.5 8Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'redo',
  type: 'solid'
}
